import React, { createContext, useContext, useEffect, useState } from "react";
import { apiUrl, brands } from "../config/config";

const BrandContext = createContext();

export const BrandProvider = ({ children }) => {

  const [brandData, setBrandData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchBrand = async () => {

      try {

        const response = await fetch(`${apiUrl}/api/brand-settings/${brands}`);

        const data = await response.json();

        setBrandData(data.data);

      } catch (error) {
        console.error("Brand API error", error);
      }

      setLoading(false);
    };

    fetchBrand();

  }, []);

  return (
    <BrandContext.Provider value={{ brandData, loading }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => useContext(BrandContext);